// src/lib/partner/partnerLearnerRoster.js

import { supabase } from "../../supabaseClient";

export async function fetchPartnerLearnerRoster(
  cohortId = null
) {
  const { data, error } =
    await supabase.rpc(
      "get_my_partner_learner_roster",
      {
        p_cohort_id:
          cohortId || null,
      }
    );

  if (error) {
    throw error;
  }

  return Array.isArray(data)
    ? data
    : [];
}